module.exports = __webpack_public_path__ + "img/logo-veteran-aware.424b7dbe.jpg";